import { render, staticRenderFns } from "./veteranPanel.vue?vue&type=template&id=772349fe&"
import script from "./veteranPanel.vue?vue&type=script&lang=js&"
export * from "./veteranPanel.vue?vue&type=script&lang=js&"
import style0 from "./veteranPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports